export default {
    text_1: "Moji klienti",
    text_2: "Moji klienti",
    text_3: "Vytvoriť klienta",
    text_4: "NÁZOV KLIENTA, FIRMY, OSOBY",
    text_5: "Meno",
    text_6: "Kontaktná osoba",
    text_7: "Hladať",
    text_8: "E-mail",
    text_9: "Telefónne číslo",
    text_10: "Posledný kontakt",
    text_48: "Spoločnosť",
    text_11: "Pripomenúť kontakt",
    text_12: "Odvetvie",
    text_13: "Poznámky",
    text_14: "Akcie",
    text_15: "Upraviť",
    text_16: "Vymazať",
    text_17: "Určite?",
    text_18: "Naozaj chcete vymazať klienta?",
    text_19: "Nie",
    text_20: "Áno",
    text_21: "Klient bol úspešne vymazaný.",

    text_22: "Fakturačné údaje",
    text_23:
        "Niektoré údaje vieme vyplniť automaticky. Zadaj IČO alebo názov firmy.",
    text_24: "Názov spoločnosti",
    text_25: "IČO",
    text_26: "DIČ",
    text_27: "IČ DPH",
    text_28: "Ulica a číslo",
    text_29: "PSČ",
    text_30: "Mesto",
    text_31: "Kontakty",
    text_32: "Ulož si kontakty na tvojho klienta.",
    text_33: "Kontaktná osoba",
    text_34: "Email",
    text_35: "Telefónne číslo",
    text_36: "Ďalšie informácie",
    text_37: "Dátum posledného kontaktu",
    text_38: "Odvetvie",
    text_39: "Poznámka",

    text_40: "Uložiť",
    text_41: "Vytvoriť klienta poznámku",

    text_42: "Treba vyplniť názov klienta.",
    text_43: "Klient bol úspešne vytvorený.",
    text_44: "Klient bol úspešne upravený.",
    text_45: "Názov klienta už existuje",

    text_46: "Pripomenúť kontakt e-mailom",
    text_47:
        "Ak zapneš túto možnosť, môžeš si nastaviť dátum, kedy ti DOFFERO e-mailom pripomenie že sa máš ozvať klientovi.",
    text_49: "Aktuálne nemáš vytvoreného žiadneho klienta.",

    text_50: "Späť",

    text_51: "Zdroj kontaktu"
};
